<template>
    <div
        class="carousel-navigation-button"
        :class="containerCssClasses"
        @click.prevent="onClick"
    >
        <svg
            aria-hidden="true"
            class="svg-inline--fa fa-chevron-left fa-w-10"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
        >
            <path 
                v-if="direction === 'prev'"
                :class="pathCssClasses"
                d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            />

            <path
                v-else-if="direction === 'next'"
                :class="pathCssClasses"
                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
            />
        </svg>
    </div>
</template>


<script>

import { propsStringEnumValidator } from "@/libs/utils";
const validatorDirection = propsStringEnumValidator(["next", "prev"]);
const validatorTheme = propsStringEnumValidator(["light", "dark"]);


export default {
    props: {
        direction: {
            type: String,
            required: true,
            validator: validatorDirection
        },
        isRounded: {
            type: Boolean,
            default: false
        },
        containerTheme: {
            type: String,
            required: true,
            validator: validatorTheme
        },
        pointerTheme: {
            type: String,
            required: true,
            validator: validatorTheme
        }
    },
    computed: {
        containerCssClasses: function(){
            const arr = [];
            if(this.isRounded) arr.push('rounded');
            
            if(this.containerTheme == 'light') arr.push('bg-light');
            else if(this.containerTheme == 'dark') arr.push('bg-dark');
            
            return arr;
        },
        pathCssClasses: function(){
            const arr = [];

            if(this.pointerTheme == 'light') arr.push('fill-light');
            if(this.pointerTheme == 'dark') arr.push('fill-dark');

            return arr;
        }
    },
    methods: {
        onClick: function() {
            this.$emit("navclick", {
                direction: this.direction
            });
        }
    }
};
</script>

<style scoped>


.carousel-navigation-button {
    width: 40px;
    height: 40px;
    
    position: relative;

    flex-shrink: 0;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 30px;
}

svg{
    width: 50%;
    height: 50%;
}

.rounded { border-radius: 100px; }

.bg-light{ background-color: rgb(172, 172, 172); }
.bg-dark{ background-color: rgba(0, 0, 0, 0.5); }

.fill-light{ fill: #ffffff; }
.fill-dark{ fill: #000000; }
</style>